import React, { useEffect } from "react";

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
import { Map, TileLayer, GeoJSON } from 'react-leaflet'
import Header from "../../../components/Headers/Header.jsx";

// style
import "../../../assets/css/loading.css";
import "../../../assets/css/map.css";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

export default function Regional() {

    const [showLoading, setshowLoading] = React.useState(false);

    const [listRegionais, setListRegionais] = React.useState(null);

    const GetListRegionais = () => {
        setshowLoading(true);
        api_GET('regional/GetWithGeoJson').then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                localStorage.setItem("regionais", JSON.stringify(result.data));
                setListRegionais(result.data);
            }
        });
    }

    useEffect(() => {
        GetListRegionais();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Header />
            <Container className="mt--9" fluid>
                <Row>
                    <Container fluid>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <Row>
                                    <Col md="6" lg="6">
                                        <strong> Lista de Divisão Administrativa</strong>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <form>
                                    <Row className="mt-4">
                                        <Col md="12">
                                            {listRegionais != null &&
                                                <div id="map">
                                                    <Map center={[-3.755019499914185, -38.5860013961792]} zoom={12}>
                                                        <TileLayer
                                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                        />
                                                        {
                                                            listRegionais.map(item => (
                                                                <GeoJSON key={item.regionalId} data={JSON.parse(item.geoJson)}></GeoJSON>
                                                            ))
                                                        }
                                                    </Map>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Container>
        </>
    );
}
